<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text"> Пользователи </span>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        @click="dialog = true"
        style="width: auto !important"
        class="button-accept"
      >
        + Добавить пользователя
      </v-btn>
    </div>
    <v-tabs
      class="container-banners-tabs"
      color="var(--app-dark-blue-1)"
      v-model="tabNumber"
    >
      <v-tab> Активные </v-tab>
      <v-tab> Заблокированные </v-tab>
      <v-tab-item>
        <div class="table-container">
          <v-data-table
            :headers="tableHeaders"
            :items="users"
            :footer-props="{
              itemsPerPageOptions: [10, 25, 50],
              'items-per-page-text': '',
            }"
            class="elevation-0 main-table"
            :items-per-page="optionTable.itemsPerPage"
            :page="optionTable.page"
            :server-items-length="optionTable.serverItemsLength"
            @pagination="tableChange"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td @click="openDialog(item)">{{ item.login }}</td>
                  <td @click="openDialog(item)">{{ item.name }}</td>
                  <td @click="openDialog(item)">{{ item.roles.title }}</td>
                  <td class="text-end" style="width: 200px">
                    <v-icon @click="updatePass(item)" style="cursor: pointer">
                      mdi-cached
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="table-container">
          <v-data-table
            :headers="tableSecondHeaders"
            :items="users"
            :footer-props="{
              itemsPerPageOptions: [10, 25, 50],
              'items-per-page-text': '',
            }"
            class="elevation-0 main-table"
            :items-per-page="optionTable.itemsPerPage"
            :page="optionTable.page"
            :server-items-length="optionTable.serverItemsLength"
            @pagination="tableChange"
            @click:row="openDialog"
          >
            <template v-slot:item.roles="{ item }">
              {{ item.roles.title }}
            </template>
          </v-data-table>
        </div>
      </v-tab-item>
    </v-tabs>

    <v-dialog width="570px" height="auto" persistent v-model="dialog">
      <v-card width="570px" height="auto" class="rounded-0">
        <v-form ref="formFirst">
          <v-card-title class="dialog-title">
            <span v-if="selectedItem && selectedItem.id" class="title"
              >Редактировать {{ selectedItem.login }}</span
            >
            <span v-else class="title">Добавить пользователя</span>
            <v-icon @click="closeDialog">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="mb-5 d-flex align-center">
              <div>
                <img
                  v-if="imgSrc"
                  class="dialog-description-image"
                  :src="imgSrc"
                />
                <div v-else class="dialog-description-skeleton-image">
                  <v-icon size="30px">mdi-account</v-icon>
                </div>
              </div>
              <v-btn
                v-if="imgSrc"
                color="var(--app-dark-blue-1)"
                class="button-accept-outlined"
                @click="onButtonClick"
                outlined
              >
                Изменить фото
              </v-btn>
              <v-btn v-else class="button-accept" @click="onButtonClick">
                Загрузить фото
              </v-btn>

              <input
                ref="uploader"
                class="d-none"
                type="file"
                accept="image"
                @change="onFileChanged"
              />
            </div>

            <v-text-field
              v-if="!selectedItem.id"
              label="Логин или почта"
              required
              type="text"
              outlined
              :rules="rules"
              v-model="selectedItem.login"
            ></v-text-field>
            <v-text-field
              label="Имя в чате"
              required
              type="text"
              outlined
              :rules="rules"
              v-model="selectedItem.name"
            ></v-text-field>
            <v-autocomplete
              label="Роль"
              outlined
              item-text="title"
              return-object
              v-model="selectedItem.roles"
              :items="roles"
            >
              <template slot="item" slot-scope="{ item }">
                <div class="d-flex justify-space-between" style="width: 100%">
                  {{ item.title }}
                  <v-icon
                    @mouseover="openInfo($event, item)"
                    @mouseleave="showInfo = false"
                    >mdi-information</v-icon
                  >
                </div>
              </template>
            </v-autocomplete>
            <v-menu
              v-model="showInfo"
              :position-x="x"
              :position-y="y"
              absolute
              offset-y
            >
              <v-card min-width="300px" min-height="100px">
                <div class="menu-container">
                  <div class="menu-container-title">Список доступов</div>
                  <div class="menu-container-text">
                    <span
                      v-for="(i, index) in findTrueItems(showItems)"
                      :key="index"
                    >
                      <template
                        v-if="index < findTrueItems(showItems).length - 1"
                      >
                        {{ i.title }}, &nbsp;
                      </template>
                      <template v-else>
                        {{ i.title }}
                      </template>
                    </span>
                  </div>
                </div>
              </v-card>
            </v-menu>
          </v-card-text>

          <v-card-actions class="dialog-buttons">
            <v-btn
              @click="saveUser"
              style="width: 120px !important"
              class="button-accept"
            >
              Сохранить
            </v-btn>
            <v-btn
              v-if="selectedItem && selectedItem.id && !selectedItem.isBlocked"
              @click="userBlock(true)"
              style="width: auto"
              class="button-accept-outlined"
              outlined
              color="var(--app-red-1)"
            >
              Заблокировать
            </v-btn>
            <v-btn
              v-else-if="
                selectedItem && selectedItem.id && selectedItem.isBlocked
              "
              @click="userBlock(false)"
              style="width: auto"
              class="button-accept-outlined"
              outlined
              color="var(--app-green-1)"
            >
              Разблокировать
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog width="600px" height="auto" persistent v-model="dialogPass">
      <v-card>
        <v-card-title class="dialog-title">
          <span class="title"
            >Пароль для нового пользователя {{ selectedItem.login }}</span
          >
          <v-icon @click="dialogPass = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <div class="dialog-description">
            <div
              class="dialog-description-text-container"
              style="color: #606060"
            >
              Скопируйте и сохраните пароль, при утере пароля вы можете его
              только сбросить.
            </div>
            <div class="dialog-description-pass-container mt-15 mb-15">
              {{ passText }}
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="dialog-buttons">
          <v-btn
            @click="textCopy"
            style="width: 150px !important"
            class="button-accept"
          >
            Скопировать
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-alert
      type="success"
      transition="scale-transition"
      class="alert-success"
      v-model="alertPass"
    >
      {{ alertText }}
    </v-alert>
    <v-divider></v-divider>
  </div>
</template>
<script>
export default {
  data: () => ({
    showInfo: false,
    block: false,
    x: null,
    y: null,
    users: [],
    roles: [],
    dialog: false,
    dialogPass: false,

    rules: [(value) => !!value || "Обязательно к заполнению"],
    selectedItem: {
      isBlocked: false,
    },
    optionTable: {
      page: 1,
      itemsPerPage: 10,
      serverItemsLength: -1,
    },
    tabNumber: 0,
    tableHeaders: [
      {
        text: "Логин / почта",
        sortable: false,
      },
      {
        text: "Имя в чате",
        sortable: false,
      },
      {
        text: "Роль",
        sortable: false,
      },
      {
        text: "Cбросить пароль",
        sortable: false,
        align: "end",
      },
    ],
    tableSecondHeaders: [
      {
        text: "Логин / почта",
        sortable: false,
        value: "login",
      },
      {
        text: "Имя в чате",
        sortable: false,
        value: "name",
      },
      {
        text: "Роль",
        sortable: false,
        value: "roles",
      },
    ],
    imgSrc: "",
    showItems: [],
    alertPass: false,
    passText: "",
    alertText: "",
  }),
  methods: {
    textCopy() {
      const container = document.querySelector(".v-dialog");

      this.$copyText(this.passText, container).then(() => {
        this.alertPass = true;
        setTimeout(() => {
          this.alertPass = false;
        }, 3000);
      });
    },
    onButtonClick() {
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.selectedItem.photo = e.target.files[0];
      this.imgSrc = URL.createObjectURL(this.selectedItem.photo);
    },
    closeDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.imgSrc = "";
        this.selectedItem = {};
        this.$refs.formFirst.resetValidation();
      }, 100);
    },
    openDialog(item) {
      this.selectedItem = Object.assign({}, item);
      if (typeof this.selectedItem.photo == "string") {
        this.imgSrc = this.selectedItem.photo;
      }
      this.dialog = true;
    },
    openInfo(e, item) {
      this.showItems = item.sections;
      e.preventDefault();

      this.x = e.clientX + 10;
      this.y = e.clientY + 10;
      this.showInfo = true;
    },
    findTrueItems(items) {
      const newArr = items.filter((i) => {
        const findItems = i.accesses.find((it) => it.value);
        if (findItems) {
          return i;
        }
      });
      return newArr;
    },
    goToCreate() {
      this.$router.push({ name: "CreateCategories" });
    },

    getUsers() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/adminPanelUser/list",
          {
            optionTable: this.optionTable,
            areBlocked: this.block,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.optionTable = res.data.optionTable;
          this.users = res.data.items;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getRoles() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV2 + "/adminPanelUser/role/list",
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.roles = res.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    saveUser() {
      if (this.$refs.formFirst.validate()) {
        let formData = new FormData();
        formData.append("roleId", this.selectedItem.roles.id);
        formData.append("name", this.selectedItem.name);
        formData.append("login", this.selectedItem.login);

        let baseURL;
        if (this.selectedItem.id) {
          baseURL = `${this.$store.getters.apiAdminPanelV2}/adminPanelUser`;
          formData.append("adminPanelUserId", this.selectedItem.id);
          formData.append("photo", this.selectedItem.photo);
        } else {
          baseURL = `${this.$store.getters.apiAdminPanelV5}/auth/create/admin`;
          formData.append("profilePhoto", this.selectedItem.photo);
        }

        this.$axios
          .post(baseURL, formData, {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          })
          .then((res) => {
            if (res.data.password) {
              this.alertText = "Пароль успешно скопирован в буфер обмена";
              this.passText = res.data.password;
              this.dialogPass = true;
            } else if (!this.selectedItem.id) {
              this.alertText = "Пароль отправлен вам на почту";
              this.alertPass = true;
              setTimeout(() => {
                this.alertPass = false;
              }, 3000);
            }

            this.closeDialog();

            this.getUsers();
          })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          });
      }
    },
    userBlock(block) {
      let formData = new FormData();
      formData.append("adminPanelUserId", this.selectedItem.id);
      formData.append("roleId", this.selectedItem.roles.id);
      formData.append("name", this.selectedItem.name);
      formData.append("login", this.selectedItem.login);
      formData.append("photo", this.selectedItem.photo);
      formData.append("isBlocked", block);

      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/adminPanelUser",
          formData,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then(() => {
          this.dialog = false;

          this.getUsers();
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    updatePass(item) {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 +
            "/adminPanelUser/password/reset",
          {
            adminPanelUserId: item.id,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          if (res.data.password) {
            this.alertText = "Пароль успешно скопирован в буфер обмена";
            this.passText = res.data.password;
            this.dialogPass = true;
          } else {
            this.alertText = "Пароль отправлен вам на почту";
            this.alertPass = true;
            setTimeout(() => {
              this.alertPass = false;
            }, 3000);
          }
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    tableChange(data) {
      this.optionTable.page = data.page;
      this.optionTable.itemsPerPage = data.itemsPerPage;
      this.getUsers();
    },
  },
  watch: {
    tabNumber() {
      if (this.tabNumber > 0) {
        (this.optionTable = {
          page: 1,
          itemsPerPage: 10,
          serverItemsLength: -1,
        }),
          (this.block = true);
        this.getUsers();
      } else {
        (this.optionTable = {
          page: 1,
          itemsPerPage: 10,
          serverItemsLength: -1,
        }),
          (this.block = false);
        this.getUsers();
      }
    },
  },
  created() {
    this.getUsers();
    this.getRoles();
  },
};
</script>
<style lang="scss" scoped>
.table-container {
  height: calc(100vh - 238px);

  .main-table {
    height: calc(100vh - 238px) !important;
    min-height: calc(100vh - 238px) !important;
    max-height: calc(100vh - 238px) !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}

.dialog-description-image {
  width: 77px;
  height: 77px;
  border-radius: 50%;
  margin-right: 20px;
  object-fit: cover;
}

.dialog-description-skeleton-image {
  width: 77px;
  height: 77px;
  border-radius: 50%;
  margin-right: 20px;
  background: #d8d8d8;
  display: flex;
  justify-content: center;
  align-items: center;
}

.alert-success {
  position: fixed;
  top: 30px;
  width: auto;
  left: 50%;
  z-index: 1000;
  transform: translate(-50%);
}
</style>
